// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PolicyTransactionPage__wrapperContainer{box-shadow:var(--GW-SHADOW-2)}", "",{"version":3,"sources":["webpack://./node_modules/gw-policytransaction-react/PolicyTransactionPage.module.scss"],"names":[],"mappings":"AAEA,8CACI,6BAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n\n.wrapperContainer {\n    box-shadow: var(--GW-SHADOW-2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperContainer": "app__PolicyTransactionPage__wrapperContainer"
};
export default ___CSS_LOADER_EXPORT___;
